module.exports = __webpack_public_path__ + "img/faqs_layout6.9de4b292.png";